/** Technical app constants only — no business data. */
export const DEFAULT_LOGO_PATH = '/assets/webfoxx_academy_logo.png';
